/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientActionLogDto } from '../../models/client-action-log-dto';
import { UpdateClientActionLogDto } from '../../models/update-client-action-log-dto';

export interface ClientActionLogControllerUpdate$Params {
  id: string;
      body: UpdateClientActionLogDto
}

export function clientActionLogControllerUpdate(http: HttpClient, rootUrl: string, params: ClientActionLogControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientActionLogDto>> {
  const rb = new RequestBuilder(rootUrl, clientActionLogControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientActionLogDto>;
    })
  );
}

clientActionLogControllerUpdate.PATH = '/api/clientActionLog/{id}';
